import { NAME_KEY, PRICE_KEY, KIND_KEY, KINDS } from "@/lib/printess/constants";

export function isProductPlaceholder(item) {
  return (
    item &&
    item[KIND_KEY] === KINDS.PRODUCT &&
    item[NAME_KEY] === "" &&
    item[PRICE_KEY] === ""
  );
}

export function updateItem(items, updatedItem) {
  return items.map((item) => (item.key === updatedItem.key ? { ...item, ...updatedItem } : item));
}

export function getCategoryChildren(items, categoryItem) {
  const categoryIndex = items.findIndex((i) => i.key === categoryItem.key);
  const nextCategoryIndex = items.findIndex(
    (item, index) => index > categoryIndex && item[KIND_KEY] === KINDS.CATEGORY
  );
  const endIndex = nextCategoryIndex === -1 ? items.length : nextCategoryIndex;
  return items.slice(categoryIndex + 1, endIndex);
}

export function getProductsUnderCategory(items, startIndex, endIndex) {
  const products = [];
  for (let i = startIndex; i < endIndex; i++) {
    if (items[i][KIND_KEY] === KINDS.PRODUCT) {
      products.push(items[i]);
    } else {
      break;
    }
  }
  return products;
}

export function preserveStableReferences(prevItems, newItems) {
  const prevKeys = prevItems.map((i) => i.key);
  return newItems.map((item, idx) => {
    const prevIdx = prevKeys.indexOf(item.key);
    return prevIdx !== -1 && prevIdx === idx ? prevItems[prevIdx] : { ...item };
  });
}
